import ArrowRightAlt from "@material-symbols/svg-500/rounded/arrow_right_alt.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const ArrowRightAltIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: ArrowRightAlt });
	return <Icon />;
};

export default memo(ArrowRightAltIcon);
